import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { selectEntities } from 'services/entities/selectors';
import { makeSelectVirtualizedTableItemValue } from 'services/virtualizedTable/selectors';

const selectEntityNames = createDeepEqualSelector(
    makeSelectVirtualizedTableItemValue(),
    selectEntities,
    (itemValue, entities) =>
        itemValue
            .map((item: any) => get(entities, [item.id, 'name']))
            .sort()
            .join(', ')
);

const makeSelectEntityNames = (): typeof selectEntityNames => selectEntityNames;

export { selectEntityNames, makeSelectEntityNames };
